import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import { OrganizationCustomFieldsService } from '../../../../core/api/services/organization-custom-fields.service';
import { BaseSelectionList } from '../base/base-selection-list.component';
import { CustomField } from './../../../../core/api/models/custom-field';

@Component({
    selector: 'custom-field-selection-list',
    templateUrl: './custom-field-selection-list.component.html',
    standalone: false
})
export class CustomFieldSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input() selectedItems: CustomField[] = []; //selected items
  @Input() model: any;

  constructor(protected currentService: OrganizationCustomFieldsService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
    this.sortKey = 'id';

    if (!this.input_label) this.input_label = 'common.customFields';
  }

  getItems() {
    this.loading = true;

    this.currentService
      .organizationCustomFieldsGetOrganizationCustomFieldsWithPagination({
        body: { pageSize: 100, pageNumber: 1 },
      })
      .pipe(
        this.baseSelectionSearchPipeOperators,
        map((items) => {
          return items?.data.items.map((item) => {
            return {
              ...item,
              optionTitle: `${item.nameFa} (${item.nameEn})`,
            };
          });
        })
      )
      .subscribe((items) => {
        this.items = items;
        let names: string[] = this.selectedItems.map((item) => {
          return item.nameEn;
        });
        this.values = items.map((item) => {
          if (names.includes(item.nameEn)) return item.id;
        });
      });
  }

  ngOnChanges() {
    let names: string[] = this.selectedItems.map((item) => {
      return item.nameEn;
    });
    this.values = this.items.map((item) => {
      if (names.includes(item.nameEn)) return item.id;
    });
  }
}
